import teamHero from "../assets/team-hero.webp";

function Team() {
  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[75vh] flex items-center justify-center">

        {/* BACKGROUND IMAGE */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${teamHero})`,
          }}
        ></div>

        {/* DARK OVERLAY */}
        <div className="absolute inset-0 bg-black/65"></div>

        {/* CONTENT */}
        <div className="relative z-10 text-center text-white px-6 max-w-4xl">

          <p className="text-yellow-500 uppercase tracking-[6px] font-semibold mb-5">
            Meet Our Legal Experts
          </p>

          <h1 className="text-5xl md:text-7xl font-bold leading-tight">
            Our Team
          </h1>

          <p className="mt-6 text-lg md:text-xl text-gray-200 leading-relaxed">
            A dedicated team of advocates committed to delivering
            exceptional legal representation with integrity,
            professionalism, and strategic insight.
          </p>

        </div>

      </section>
      <section className="py-28 px-6 md:px-16 bg-[#F8F8F8]">

  <div className="max-w-7xl mx-auto">

    {/* HEADER */}
    <div className="text-center max-w-3xl mx-auto mb-20">

      <p className="text-yellow-600 font-semibold uppercase tracking-[6px] mb-4">
        Organizational Structure
      </p>

      <h2 className="text-4xl md:text-5xl font-bold text-[#0B1C39] mb-6">
        Our Team Structure
      </h2>

      <p className="text-gray-600 leading-relaxed text-lg">
        Our structure is intentionally designed to provide every client
        with personalized attention, strategic legal guidance, and efficient
        service delivery across all matters.
      </p>

    </div>

    {/* STRUCTURE GRID */}
    <div className="grid md:grid-cols-2 gap-8">

      {/* CARD */}
      <div className="bg-white rounded-2xl shadow-md p-8 border-l-4 border-yellow-500">
        <h3 className="text-2xl font-bold text-[#0B1C39] mb-3">
          Managing Advocate
        </h3>

        <p className="text-gray-600 leading-relaxed">
          Lead counsel, complex litigation, and overall client strategy.
        </p>
      </div>

      {/* CARD */}
      <div className="bg-white rounded-2xl shadow-md p-8 border-l-4 border-yellow-500">
        <h3 className="text-2xl font-bold text-[#0B1C39] mb-3">
          Associate Advocate
        </h3>

        <p className="text-gray-600 leading-relaxed">
          Handles conveyancing, family law, and alternative dispute resolution matters.
        </p>
      </div>

      {/* CARD */}
      <div className="bg-white rounded-2xl shadow-md p-8 border-l-4 border-yellow-500">
        <h3 className="text-2xl font-bold text-[#0B1C39] mb-3">
          Legal Assistant
        </h3>

        <p className="text-gray-600 leading-relaxed">
          Supports client intake, document drafting, and court filings.
        </p>
      </div>

      {/* CARD */}
      <div className="bg-white rounded-2xl shadow-md p-8 border-l-4 border-yellow-500">
        <h3 className="text-2xl font-bold text-[#0B1C39] mb-3">
          External Partner
        </h3>

        <p className="text-gray-600 leading-relaxed">
          Provides specialized tax and intellectual property legal counsel on referral.
        </p>
      </div>

      {/* SECRETARY CARD FULL WIDTH */}
      <div className="md:col-span-2 bg-white rounded-2xl shadow-md p-8 border-l-4 border-yellow-500">

        <h3 className="text-2xl font-bold text-[#0B1C39] mb-4">
          Secretary
        </h3>

        <p className="text-gray-600 leading-relaxed">
          Serves as the first point of contact by managing calls, emails,
          client appointments, and maintaining both physical and digital files.
          The secretary also schedules court reminders, liaises with court
          registries, welcomes walk-in clients at Plutos House, and ensures
          smooth firm-wide organization and timely communication.
        </p>

      </div>

    </div>

    {/* BOTTOM STATEMENT */}
    <div className="mt-16 text-center max-w-4xl mx-auto">

      <p className="text-xl text-[#0B1C39] font-medium leading-relaxed">
        We are intentionally lean to guarantee every client receives
        senior-level attention on every matter.
      </p>

    </div>

  </div>

</section>
    </>
  );
}

export default Team;